<template>
  <SendByEmailDialog :is-open="isDialogOpened"
                     :cancelDisabled="archivesStore.sendArchivesPending"
                     :okLoading="archivesStore.sendArchivesPending"
                     :title="$t('archives.dialogs.ArchivesSendDialog.title', archivesStore.selectedDocuments.length)"
                     @cancel="closeDialog"
                     @send="sendArchives"
  />
</template>

<script>
import SendByEmailDialog from '@/common/dialogs/SendByEmailDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { useArchivesStore } from '@/stores/archivesStore'

export default {
  name: 'ArchivesSendDialog',
  components: { SendByEmailDialog },
  mixins: [dialogMixin],
  setup() {
    const archivesStore = useArchivesStore()
    return { archivesStore }
  },
  computed: {
    selectedArchivesFilesIds () {
      return this.archivesStore.selectedDocuments.map(doc => doc.id)
    },
  },
  methods: {
    async sendArchives (emails) {
      if (!emails) return

      try {
        await this.archivesStore.sendArchives({
          params: {
            archivesFilesIds: this.selectedArchivesFilesIds,
            emails: emails,
          },
        })

        toast.success(this.$t('archives.dialogs.ArchivesSendDialog.sendSuccess'))
        this.closeDialog()
      } catch (error) {
        const errorMessage = error.response?.data?.errorCode === 'ERR_INVALID_RIGHTS' ? 'sendInvalidRightsError' : 'sendError'
        toast.error(this.$t(`archives.dialogs.ArchivesSendDialog.${errorMessage}`))
      }
    },
  },
}
</script>
